export const Tabs = [
  {
    id: 1,
    title: 'Неназначенные заявки',
    count: 'danger',
    filter: items => items.filter(item => !item.mentor_email && !item.flow_archived),
    roles: ['master']
  },
  {
    id: 2,
    title: 'Распределенные заявки',
    count: 'success',
    filter: items => items.filter(item => item.mentor_email && !item.flow_archived),
    roles: ['master']
  },
  {
    id: 3,
    title: 'Менторы',
    roles: ['master']
  },
  {
    id: 4,
    title: 'Неподтвержденные заявки',
    count: 'danger',
    filter: items => items.filter(item => !item.mentor_confirmed && !item.flow_archived),
    roles: ['mentor']
  },
  {
    id: 5,
    title: 'В работе',
    count: 'success',
    filter: items => items.filter(item => (item.mentor_email && item.mentor_confirmed) && !item.flow_archived),
    roles: ['mentor']
  },
  {
    id: 6,
    title: 'Архив заявок',
    roles: ['master', 'mentor'],
    count: 'default',
    filter: items => items.filter(item => item.flow_archived),
  },
];
